module.exports = __webpack_public_path__ + "img/wqcl3.aeeee880.png";